<template>
  <v-dialog
    v-bind:value="showModal"
    :persistent="persistentModal ? persistentModal : false"
    :width="dialogSize"
    :max-width="maxWidth || '95%'"
    scrollable
    @click:outside="handleClickOutside"
    @keydown.esc="handleClickOutside"
  >
    <v-card class="text-sm-left pb-3">
      <v-toolbar
        :color="toolbarColorValue"
        dark
        class="text-xs-left"
      >
        <div class="title-message title">
          {{title}}
        </div>
        <slot name="title-buttons"></slot>
      </v-toolbar>
      <v-card-text class="pb-0 mb-0">
        <slot name="content"></slot>
      </v-card-text>
      <v-card-actions class="pt-0 mt-0">
        <slot name="buttons"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: [
    'showModal',
    'title',
    'toolbarColor',
    'dialogSize',
    'persistent',
    'maxWidth'
  ],
  computed: {
    persistentModal () {
      return this.persistent === undefined ? true : this.persistent
    },
    toolbarColorValue () {
      return this.toolbarColor || 'blue darken-3'
    }
  },
  methods: {
    handleClickOutside () {
      this.$emit('clickOutside')
    }
  }
}
</script>

<style scoped>

.title-message {
  width: 100%
}

</style>
